<template>
  <div>
    <div class="custom-title-container">
      <img class="custom-title-bg" src="@/assets/Typing/TypingPageTitleBackground.png" />
      <img class="custom-thumbnail" src="@/assets/Typing/thumbnail.png" />
      <label class="custom-title-text">{{ $t('AppLayout.typingTitle') }}</label>
    </div>
    <div class="card-container">
      <b-tabs active-nav-item-class="font-weight-bold text-danger" justified lazy>
        <b-tab
          title-link-class="text-success"
          :title="$t('Typing.single')+$t('Typing.practice')"
          @click="onTab1Clicked"
          :active="lastTypingActive === 1"
        >
          <div class="tab-content-container">
            <TypingSingleLessonList />
          </div>
        </b-tab>
        <b-tab
          title-link-class="text-success"
          :title="$t('Typing.combine')+$t('Typing.practice')"
          @click="onTab2Clicked"
          :active="lastTypingActive === 2"
        >
          <div class="tab-content-container">
            <TypingCombineLessonList />
          </div>
        </b-tab>
        <b-tab
          title-link-class="text-success"
          :title="$t('Typing.essay')"
          @click="onTab3Clicked"
          :active="lastTypingActive === 3"
        >
          <div class="tab-content-container">
            <TypingEssayLessonList />
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'
import TypingSingleLessonList from '@/components/Typing/TypingSingle/TypingSingleLessonList'
import TypingCombineLessonList from '@/components/Typing/TypingCombine/TypingCombineLessonList'
import TypingEssayLessonList from '@/components/Typing/TypingEssay/TypingEssayLessonList'

const Typing = Vue.extend({
  name: 'Typing',
  components: {
    TypingSingleLessonList,
    TypingCombineLessonList,
    TypingEssayLessonList
  },
  props: {
    activeTab: {
      type: Number,
      required: false,
      default: 0
    }
  },
  mounted () {
    if (this.activeTab) {
      localStorage.lastTypingActive = this.activeTab
    } else if (!localStorage.lastTypingActive) {
      localStorage.lastTypingActive = '1'
    }
  },
  computed: {
    lastTypingActive () {
      return Number(localStorage.lastTypingActive)
    }
  },
  methods: {
    onTab1Clicked () {
      localStorage.lastTypingActive = '1'
    },
    onTab2Clicked () {
      localStorage.lastTypingActive = '2'
    },
    onTab3Clicked () {
      localStorage.lastTypingActive = '3'
    }
  }
})

export default Typing
</script>

<style lang='scss' scoped>
.custom-title-container {
  margin: 0;
}
.custom-title-bg {
  padding: 0;
  size: 1920px 310px;
  min-width: 1920px;
  max-height: 310px;
}
.custom-thumbnail {
  position: absolute;
  left: 50%;
  top: 120px;
  transform: translateX(-50%);
  max-width: 170px;
}
.custom-title-text {
  position: absolute;
  left: 50%;
  top: 300px;
  transform: translateX(-50%);
  color: white;
  font-size: 3rem;
  font-weight: 700;
}

.card-container {
  margin: 0rem 1rem;
}

.tab-content-container {
  background-image: url("../../assets/newest_background.png");
}
</style>
